export const SET_Wiki_Create_Config = 'SET_Wiki_Create_Config';
